export const promotionsActionTypes = {
  SELECT_PROMO: "SELECT_PROMO",
  SELECT_PROMO_2: "SELECT_PROMO_2",
  SELECT_PROMO_TOGGLE: "SELECT_PROMO_TOGGLE",
  READ_MORE: "READ_MORE",
  PLAYGROUND_LIVE: "PLAYGROUND_LIVE",
  PLAYGROUND_LIVE_CART_IMG: "PLAYGROUND_LIVE_CART_IMG",
};
